import { datadogRum } from '@datadog/browser-rum'

type DatadogContext = Record<string, unknown>

export const DATADOG_SERVICE_NAME = 'justlockit-client'

export const isDatadogRumInitialized = () =>
  Boolean(datadogRum.getInitConfiguration())

export const addDatadogAction = (
  name: string,
  context?: DatadogContext
) => {
  if (!isDatadogRumInitialized()) {
    return
  }

  datadogRum.addAction(name, context)
}

export const addDatadogError = (
  message: string,
  error?: unknown,
  context?: DatadogContext
) => {
  if (!isDatadogRumInitialized()) {
    return
  }

  datadogRum.addError(error ?? new Error(message), {
    message,
    ...context,
  })
}

export const setDatadogUser = (
  user:
    | {
        uid: string
        displayName?: string | null
        providerId?: string | null
      }
    | null
    | undefined
) => {
  if (!isDatadogRumInitialized()) {
    return
  }

  if (!user) {
    datadogRum.clearUser()
    return
  }

  datadogRum.setUser({
    id: user.uid,
    name: user.displayName ?? undefined,
    provider: user.providerId ?? 'firebase',
  })
}
